import React from 'react'
import BreadCrumb from 'components/BreadCrumb'

export default function PageHeader({ crumbs, title, description, right }) {
  return (
    <div className="w-full mb-5">
      <BreadCrumb items={crumbs} />

      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-bold text-dark-blue">{title}</h1>
          {description && <p className="text-sm text-secondary mt-1">{description}</p>}
        </div>

        {right}
      </div>
    </div>
  )
}
